import React from 'react';
import { XIcon, Copy, ExternalLinkIcon } from 'lucide-react';
export const RedeemModal = ({
  coupon,
  onClose
}) => {
  return <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4" data-id="element-167">
      <div className="bg-white rounded-xl max-w-md w-full max-h-[90vh] overflow-y-auto" data-id="element-168">
        <div className="p-4 border-b border-gray-200 flex items-center justify-between" data-id="element-169">
          <h3 className="font-medium" data-id="element-170">How to redeem this coupon</h3>
          <button onClick={onClose} className="p-1 rounded-full hover:bg-gray-100" data-id="element-171">
            <XIcon size={20} data-id="element-172" />
          </button>
        </div>
        <div className="p-6" data-id="element-173">
          <div className="mb-6" data-id="element-174">
            <div className="flex items-center mb-4" data-id="element-175">
              <div className="w-10 h-10 bg-gray-100 rounded-full flex items-center justify-center mr-3" data-id="element-176">
                {coupon?.logo}
              </div>
              <div data-id="element-177">
                <h4 className="font-medium" data-id="element-178">{coupon?.brand}</h4>
                <p className="text-sm text-gray-600" data-id="element-179">{coupon?.description}</p>
              </div>
            </div>
            <div className="bg-gray-100 p-3 rounded-lg flex items-center justify-between mb-4" data-id="element-180">
              <span className="font-mono font-medium" data-id="element-181">{coupon?.code}</span>
              <button className="text-blue-600 flex items-center text-sm" data-id="element-182">
                <Copy size={14} className="mr-1" data-id="element-183" />
                Copy
              </button>
            </div>
          </div>
          <div className="space-y-4" data-id="element-184">
            <h4 className="font-medium" data-id="element-185">How to use this coupon:</h4>
            <ol className="list-decimal pl-5 space-y-2 text-sm" data-id="element-186">
              <li data-id="element-187">Copy the coupon code above</li>
              <li data-id="element-188">Go to the {coupon?.brand} website</li>
              <li data-id="element-189">Add items to your cart</li>
              <li data-id="element-190">Enter the coupon code at checkout</li>
              <li data-id="element-191">Enjoy your discount!</li>
            </ol>
            <div className="text-sm text-gray-500 mt-4" data-id="element-192">
              <h5 className="font-medium mb-1" data-id="element-193">Terms & Conditions:</h5>
              <ul className="list-disc pl-5 space-y-1" data-id="element-194">
                <li data-id="element-195">Valid until {coupon?.expires}</li>
                <li data-id="element-196">Cannot be combined with other offers</li>
                <li data-id="element-197">Restrictions may apply</li>
              </ul>
            </div>
            <div className="mt-6" data-id="element-198">
              <a href="#" className="flex items-center justify-center w-full bg-blue-600 text-white py-3 rounded-lg font-medium hover:bg-blue-700" data-id="element-199">
                <ExternalLinkIcon size={18} className="mr-2" data-id="element-200" />
                Go to {coupon?.brand}
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>;
};